export default __webpack_public_path__ + "static/media/networth.eea2ef02.png";